// audioRemixColors.ts — Deterministic character-to-color mapping for the Mixer

import type { CharacterColorTokens } from './audioRemixTypes'

const WARM_PALETTE: CharacterColorTokens[] = [
  { fg: '#f0a670', bg: 'rgba(240,166,112,0.14)', border: 'rgba(240,166,112,0.28)', wave: '#f0a670' },
  { fg: '#c78d8d', bg: 'rgba(199,141,141,0.14)', border: 'rgba(199,141,141,0.28)', wave: '#c78d8d' },
  { fg: '#8ecb8e', bg: 'rgba(142,203,142,0.14)', border: 'rgba(142,203,142,0.28)', wave: '#8ecb8e' },
  { fg: '#e8b960', bg: 'rgba(232,185,96,0.14)', border: 'rgba(232,185,96,0.28)', wave: '#e8b960' },
  { fg: '#e07878', bg: 'rgba(224,120,120,0.14)', border: 'rgba(224,120,120,0.28)', wave: '#e07878' },
  { fg: '#7cc8c8', bg: 'rgba(124,200,200,0.14)', border: 'rgba(124,200,200,0.28)', wave: '#7cc8c8' },
  { fg: '#d4a0d4', bg: 'rgba(212,160,212,0.14)', border: 'rgba(212,160,212,0.28)', wave: '#d4a0d4' },
  { fg: '#a8c870', bg: 'rgba(168,200,112,0.14)', border: 'rgba(168,200,112,0.28)', wave: '#a8c870' },
]

const COOL_PALETTE: CharacterColorTokens[] = [
  { fg: '#a78bfa', bg: 'rgba(167,139,250,0.14)', border: 'rgba(167,139,250,0.28)', wave: '#a78bfa' },
  { fg: '#818cf8', bg: 'rgba(129,140,248,0.14)', border: 'rgba(129,140,248,0.28)', wave: '#818cf8' },
  { fg: '#67e8f9', bg: 'rgba(103,232,249,0.14)', border: 'rgba(103,232,249,0.28)', wave: '#67e8f9' },
  { fg: '#94a3b8', bg: 'rgba(148,163,184,0.14)', border: 'rgba(148,163,184,0.28)', wave: '#94a3b8' },
]

const ORIG_COLOR: CharacterColorTokens = {
  fg: '#8aa2b4', bg: 'rgba(138,162,180,0.10)', border: 'rgba(138,162,180,0.22)', wave: '#6b7a86',
}

function hashString(s: string): number {
  let h = 0
  for (let i = 0; i < s.length; i++) {
    h = ((h << 5) - h + s.charCodeAt(i)) | 0
  }
  return Math.abs(h)
}

const _cache = new Map<string, CharacterColorTokens>()

export function getCharacterColor(name: string, type?: 'dialogue' | 'voiceover'): CharacterColorTokens {
  if (name === 'Orig') return ORIG_COLOR
  const key = `${name}:${type ?? ''}`
  const cached = _cache.get(key)
  if (cached) return cached
  const palette = type === 'voiceover' ? COOL_PALETTE : WARM_PALETTE
  const color = palette[hashString(name) % palette.length]
  _cache.set(key, color)
  return color
}
